import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ServicesService } from 'src/services/services.service';

@Component({
  selector: 'app-so-event-detail',
  templateUrl: './so-event-detail.component.html',
  styleUrls: ['./so-event-detail.component.scss']
})
export class SoEventDetailComponent {
  eventForm!: FormGroup;

  selectedImage: File | null = null;
  imagePreview: string | null = null;
  so_event_id: any;

  constructor(private fb: FormBuilder,
    private apiService: ServicesService
  ) { }

  ngOnInit(): void {
    this.so_event_id = sessionStorage.getItem('SO_Event_ID');
    this.getSoEventDetail();
    this.eventForm = this.fb.group({
      event_name: ['', Validators.required],
      address: ['', Validators.required],
      from_date: ['', Validators.required],
      to_date: ['', Validators.required],
    });
  }

  getSoEventDetail() {
    this.apiService.getSoEventDetail(this.so_event_id).subscribe(
      (data: any) => {
        const eventDetail = data.data[0];

        this.eventForm.patchValue({
          event_name: eventDetail.event_name,
          address: eventDetail.address,
          from_date: eventDetail.from_date,
          to_date: eventDetail.to_date,
        });
      })
  }

  onSubmit(): void {
    if (this.eventForm.invalid) {
      this.eventForm.markAllAsTouched();
      return;
    }

    // Format date properly (YYYY-MM-DD)
    const fromDate = this.formatDate(this.eventForm.value.from_date);
    const toDate = this.formatDate(this.eventForm.value.to_date);

    // Final API Payload (FLAT STRUCTURE)
    const finalPayload = {
      so_event_id: this.so_event_id,
      event_name: this.eventForm.value.event_name,
      event_address: this.eventForm.value.address,
      from_date: fromDate,
      to_date: toDate,
      created_by: sessionStorage.getItem('User_ID')
    };

    // 🚀 If image selected → upload first
    if (this.selectedImage) {
      this.uploadImageAndSubmit(finalPayload);
    } else {
      this.submitEvent(finalPayload);
    }
  }

  uploadImageAndSubmit(payload: any) {

    const reader = new FileReader();

    reader.onload = () => {
      const base64Image = reader.result;

      this.apiService.uploadimage(base64Image, '0/stall')
        .subscribe((res: any) => {

          payload.image_name = res.image_name; // image returned from backend
          this.submitEvent(payload);

        });
    };

    reader.readAsDataURL(this.selectedImage as File);
  }

  submitEvent(payload: any) {
    this.apiService.editSoEventDetail(payload)
      .subscribe((res: any) => {

        console.log('API Response:', res);

        if (res.flag === true) {
          alert(res.msg);
        } else {
          alert('Something went wrong');
        }

      });
  }

  formatDate(date: any): string {
    const d = new Date(date);
    const month = ('0' + (d.getMonth() + 1)).slice(-2);
    const day = ('0' + d.getDate()).slice(-2);
    return `${d.getFullYear()}-${month}-${day}`;
  }

  onReset(): void {
    this.eventForm.reset();
    this.selectedImage = null;
    this.imagePreview = null;
  }
}
